<template>
    <div class="list-raovat">
        <div class="d-flex  justify-content-between">
            <h1>Danh sách từ khóa cấm</h1>
            <button type="button" class="btn btn-success btn-sm px-3 mr-2 " style="height: max-content"
                    @click="create">
                <i class="icon ion-md-add"></i>
            </button>
        </div>
        <!-- table list rao vặt -->
        <table :class="{
                'table': true,
                'table-borderless': $detect == 'web'
            }">
            <!-- thead web -->
            <thead v-if="$detect == 'web'">
            <tr>
                <th scope="col" class="text-center">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input"
                               id="select-all-table" v-model="selectAll"/>
                        <label class="custom-control-label" for="select-all-table"></label>
                    </div>
                </th>
                <th scope="col">Từ khóa</th>
                <th scope="col" class="text-center">Trạng thái</th>
                <th scope="col" class="text-center">Thao tác</th>
            </tr>
            </thead>
            <!-- hết thead web -->

            <!-- thead mobile -->
            <thead v-else>
            <tr>
                <th scope="col" class="text-center py-1">
                        <span class="check-all-mobile" @click="selectAll = !selectAll">
                            <img :src="selectAll ? $urlImage('/images/selected.svg') : $urlImage('/images/unselect.svg')"/>
                        </span>
                </th>
                <th scope="col" class="text-center py-1">Thông tin</th>
            </tr>
            </thead>
            <!-- hết thead mobile -->

            <!-- tbody -->

            <!-- check xem có dữliệu hay không -->
            <tbody v-if="raovat.length == 0">
            <tr>
                <td colspan="4" class="text-center text-muted">Không có dữ liệu</td>
            </tr>
            </tbody>

            <!-- có dữ liệu -->
            <!-- tbody web -->
            <tbody v-else-if="$detect == 'web'">
            <tr :class="{
                        'position-relative': true,
                    }" v-for="(item,index) in raovat" :key="index">
                <!-- td checkbox -->
                <td scope="row" style="white-space: nowrap;">
                    <div class="custom-control custom-checkbox text-center">
                        <input type="checkbox" class="custom-control-input"
                               :id="item.rej_id" :value="item.rej_id" v-model="idSelect"/>
                        <label class="custom-control-label" :for="item.rej_id"></label>
                    </div>
                </td>
                <!-- td ảnh rao vặt -->
                <td   >
                    {{item.rej_keyword}}
                </td>
                <td  class="text-center">
                    <div :class="{
                                    'text-right': false,
                                    'text-success': item.rej_active == 1,
                                    'text-danger': item.rej_active != 1,
                                }">
                                {{ item.rej_active == 1 ? 'Hoạt động' : 'Không hoạt động'}}
                    </div>
                </td>
                <td width="150" class="text-center">
                    <button type="button" class="btn btn-success btn-sm px-3 mr-2"
                            @click="update(item)">
                        <i class="icon ion-md-create"></i>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm px-3"
                            @click="destroy(item)">
                        <i class="icon ion-md-trash"></i>
                    </button>
                </td>
            </tr>
            </tbody>
            <!-- hết tbody web -->

            <!-- tbody mobile -->
            <tbody v-else>
            <tr :class="{
                        'table-mobile position-relative': true,
                    }" v-for="(item, index) in raovat" :key="index">
                <!-- td ảnh và checkbox -->
                <td class="img-tab position-relative pl-1">
                    <div class="checkbox-mobile position-absolute"
                    >
                        <input type="checkbox" class="d-none" v-model="idSelect"
                               :value="item.id" :id="item.id"/>
                        <label class="checkbox-label" :for="item.id">
                            <img :src="idSelect.includes(item.id) ? $urlImage('/images/selected.svg') : $urlImage('/images/unselect.svg')"/>
                        </label>
                    </div>
                </td>
                <!-- td thông tin -->
                <!-- click thông tin là show model xử lý -->
                <!-- <td style="width: calc(100% - 100px)" @click="actionItem(item)"> -->
                <td  :width="widthTable - 100" class="position-relative"
                     @click="activeTr = index">
                    <div class="name">{{item.rej_keyword}}</div>
                    <div class="mt-2" v-if="screenWidth <= 320">
                            <span :class="{
                                    'text-right': false,
                                    'text-success': item.rej_active == 1,
                                    'text-danger': item.rej_active != 1,
                                }">
                                    <div >
                                        {{ item.rej_active == 1 ? 'Hoạt động' : 'Không hoạt động'}}
                                    </div>
                            </span>
                    </div>
                </td>
            </tr>
            </tbody>
            <!-- hết tbody mobile -->
        </table>
        <paginate
            :current_page="current_page"
            :next_page="next_page"
            :last_page="last_page"
            :callData="getData"/>

        <action :visible.sync="visible" :data="itemaction"></action>

    </div>
</template>
<script>
export default {
    components: {
        paginate: () => import('@/components/layout/pagination.vue'),
        action : () => import('./action.vue')
    },
    data(){
        return {
            raovat: [], // data rao vặt
            activeTr: '', // hiện tại k sử dụng (check lại)
            current_page: 0, // page hiện tại
            next_page: 0, // next page
            last_page: 0, // last page
            idSelect: [], // id rao vặt select để sử lý muti
            data_fillter: {
                keyword: this.$route.query.keyword,
                page: this.$route.query.page ? this.$route.query.page*1 : 1,
                limit : this.$route.query.limit ? this.$route.query.limit*1 : 100,
            }, // data fillter
            selectAll: false, // trạng thái có select all hay không
            dataActionItem: {}, // data xử lý đơn
            showModel: false, // show model xử lý đơn moblie
            screenWidth: window.screen.width, // lấy kích thước màn hình
            dialog: false, // show dialog xử lý up vip, up siêu vip
            action: '', // loại xử lý (up vip hoặc up siêu vip) để có giao diện khác
            itemaction: '', // data xử lý đơn
            loading: '', // loading theo tr
            loadingAction: '', // loading theo xử lý
            dialogApprove: false, //trạng thái bật lý do không được duyệt
            approve: null, // lý do không được phê duyệt
            visible : false
        }
    },
    created() {
        apiGet('/v2/profile/keyword-reject', this.data_fillter).then(res => {
            let data = res.data;
            this.raovat = data.data;
            this.last_page = data.last_page;
            this.next_page = data.next_page;
            this.current_page = data.current_page;
            this.selectAll = false;
        });
        this.$eventBus.$on('call-rv-current-page', () => this.getData((this.current_page)))
    },
    methods: {
        /**
         *  lấy data rao vặt
         *
         *  page: page cần lấy dữu liệu
         */
        async getData(page){
            // lấy data fillter
            let fillter = {
                page: page,
                limit : this.data_fillter.limit,
                keyword: this.data_fillter.keyword,
            };
            let query = {};
            if(fillter.page) query.page = fillter.page;
            if(fillter.limit) query.limit = fillter.limit;
            if(fillter.keyword) query.keyword = fillter.keyword;
            this.$router.push({
                name: 'keyword-reject',
                query: query
            })
        },

        /**
         *  lấy data đẩy vào model xử lý đơn mobile
         */
        actionItem(item){
            this.dataActionItem = item;
            this.showModel = true;
        },

        /**
         * push id rao vặt mobile
         */
        pushIdMuti(item){
            if(this.idSelect.includes(item.rej_id)){
                let index = this.idSelect.indexOf(item.rej_id);
                this.idSelect.splice(index, 1);
            }else{
                this.idSelect.push(item.rej_id);
            }
        },

        /**
         * xử lý đơn
         *
         * item: data xử lý
         * check: loại xử lý
         */
        actionUpItem(item, check){
            this.itemaction = item;
            this.action = check;
            this.dialog = true;
        },
        destroy(item){
            this.$confirm('Bạn có chắc chắn xóa bài viết?', 'Xóa bài viết', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'error'
            }).then(async res => {
                await apiDelete('/v2/profile/keyword-reject/'+item.rej_id).then(res => {
                    if(res.status == 204){
                        this.$message({
                            message: 'Thao tác thành công',
                            type: 'success',
                            center: true,
                        });

                    }else{
                        this.$message({
                            message: res.data.message,
                            type: 'warning',
                            center: true,
                        });
                    }
                    this.getData(1)
                });
            }).catch(() => {})
        },

        hiden(){
            setTimeout(() => {
                this.activeTr = '';
            }, 0)
        },
        update(val){
            this.itemaction = val
            this.visible = true
        },
        create () {
            this.visible = true
        }
    },
    watch: {
        query:{
            handler(val){
                apiGet('/v2/profile/keyword-reject', {
                    keyword: val.keyword,
                    page: val.page ? val.page*1 : 1,
                    limit: val.limit ? val.limit*1 : 100,
                }).then(res => {
                    let data = res.data;
                    this.raovat = data.data;
                    this.last_page = data.last_page;
                    this.next_page = data.next_page;
                    this.current_page = data.current_page;
                    this.selectAll = false;
                });
            },
            deep: true
        },
        data_fillter: {
            handler(val){
                this.getData(1)
            },
            deep: true
        },
        selectAll(val){
            this.idSelect = [];
            if(val){
                this.raovat.map(item => {
                    this.idSelect.push(item.rej_id);
                })
            }
        },
        idSelect: {
            handler(val){
                let count = 0;
                this.raovat.map(item => {
                        count += 1;
                });
                if(val.length == count && count > 0){
                    this.selectAll = true;
                }
            },
            deep: true,
        },
        showModel(val){
            if(!val){
                this.dataActionItem = {};
            }
        }
    },
    computed: {
        widthTable(){
            let table = document.querySelector('table');
            return table.clientWidth;
        },
        query(){
            return this.$route.query;
        }
    },
}
</script>
